<template>
  <div class="form-wrapper">
    <div v-if="isLoading" class="loader">
      <v-progress-circular indeterminate color="primary" />
    </div>
    <form id="payment-form" class="payment-form" @submit.prevent="handleSubmit">
      <div id="payment-element">
        <!--Stripe.js injects the Payment Element-->
      </div>
      <div class="payment-form__actions">
        <ui-button @click="$router.push({ name: 'invoice-data' })">{{
          $t("message.common.back")
        }}</ui-button>
        <ui-button
          type="submit"
          color="primary"
          class="payment-form__submit-btn"
          >{{ $t("message.payments.payNow") }}</ui-button
        >
      </div>

      <div id="payment-message" class="hidden"></div>
    </form>
  </div>
</template>

<script>
import { loadStripeScript } from "@/helpers/load-stripe-script";
import serviceHandler from "@/helpers/handlers/service";
import PaymentsService from "@/services/payments";
import { GTM_EVENT_NAME } from "@/enums/gtm-events";
import { LOCAL_STORAGE_KEYS } from "@/enums/local-storage";

export default {
  name: "PaymentsPeriodSwitch",
  data() {
    return {
      elements: null,
      isLoading: true,
      stripe: null
    };
  },
  created() {
    this.selected = this.value;
  },

  computed: {
    currency() {
      return this.$store.state.payments.currency;
    },
    countryCode() {
      return this.$store.state.company.company.country_code;
    },
    selectedPaymentMethod() {
      return this.$store.state.payments.selectedPaymentMethod;
    }
  },
  async mounted() {
    await loadStripeScript();
    await this.initialize();
  },
  methods: {
    async initialize() {
      if (
        !this.$store.state.payments.selectedPaymentMethod ||
        !this.$store.getters["payments/getPriceId"]
      ) {
        this.$router.push({ name: "order-details" });
      }
      const paymentMethod = this.$store.state.payments.selectedPaymentMethod
        .value;
      const locationsCount = this.$store.state.payments.selectedLocationsCount;
      const priceId = this.$store.getters["payments/getPriceId"];
      this.isLoading = true;

      this.stripe = window.Stripe(process.env.VUE_APP_STRIPE_PK);
      const promoCode = this.$store.state.payments.promoCode;
      const clientId = localStorage.getItem(LOCAL_STORAGE_KEYS.CLIENT_ID);
      const sessionId = localStorage.getItem(LOCAL_STORAGE_KEYS.SESSION_ID);
      const { client_secret: clientSecret } = await serviceHandler(
        PaymentsService.postOrder({
          currency: this.currency,
          method_type: paymentMethod,
          ...(promoCode && { promotion_code: promoCode }),
          items: [
            {
              price: priceId,
              quantity: locationsCount
            }
          ],
          client_id: clientId,
          ...(sessionId && { session_id: sessionId })
        })
      );

      const appearance = {
        theme: "stripe"
      };
      this.elements = this.stripe.elements({ appearance, clientSecret });

      const paymentElementOptions = {
        layout: "tabs",
        defaultValues: {
          billingDetails: {
            address: {
              country: this.countryCode.toUpperCase() // Set the default country code
            }
          }
        }
      };

      const paymentElement = this.elements.create(
        "payment",
        paymentElementOptions
      );
      paymentElement.mount("#payment-element");
      this.isLoading = false;
    },

    async handleSubmit() {
      this.setLoading(true);

      this.$gtm.trackCustomEvent({
        event: GTM_EVENT_NAME.PAYMENT_STARTED,
        selected_payment_method:
          this.selectedPaymentMethod.value === "p24"
            ? "fast_bank_transfers"
            : this.selectedPaymentMethod.value
      });
      const locationOrigin = window.location.origin;
      const { error } = await this.stripe.confirmPayment({
        elements: this.elements,
        confirmParams: {
          return_url: `${locationOrigin}/payment-completed`
        }
      });
      if (error.type === "card_error" || error.type === "validation_error") {
        this.showMessage(error.message);
      } else {
        this.showMessage("An unexpected error occurred.");
      }

      this.setLoading(false);
    },
    showMessage(messageText) {
      return;
    },
    setLoading(isLoading) {
      if (isLoading) {
        // Disable the button and show a spinner
        this.isLoading = true;
      } else {
        this.isLoading = false;
      }
    }
  },
  beforeDestroy() {
    if (this.stripe) {
      this.stripe = null;
      this.elements = null;
      const elementsElement = document.getElementById("payment-element");
      if (elementsElement) {
        elementsElement.innerHTML = "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.payment-form {
  &__submit-btn {
    flex-grow: 1;
  }
  &__actions {
    display: flex;
    gap: $spacing * 2;
    margin-top: $spacing * 3;
  }
}

.form-wrapper {
  position: relative;
  min-height: 200px;
}

#payment-element,
#payment-form {
  min-height: 200px;
}

.loader {
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  background: white;
  z-index: 2;
  height: 100%;
}
</style>
